export default __webpack_public_path__ + "static/media/sampleDog2.e8ef6b91.jpeg";